import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  CircularProgress,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#f0f0f0',
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.primary,
    },
  },
}))(TableRow);

export default function ReportTable(props) {
  return (
    <Box p={3}>
      {!props.loading ? (
        <TableContainer>
          <Table
            // stickyHeader
            // className={classes.table}
            size="small"
            // aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                {props.columns.map((column, i) => (
                  <StyledTableCell
                    key={i}
                    width="auto"
                    align={column.align ? column.align : 'center'}
                  >
                    {column.name}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{props.children}</TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </div>
      )}
    </Box>
  );
}
